export default "__VITE_ASSET__lEpV2Pen__"